import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
// ScrollReveal import removed since we aren't using it anymore

import Hero from "../components/homepage/Hero";
import ImageSection from "../components/homepage/ImageSection";
import BrandStory from "../components/homepage/BrandStory";
import SlidingGallery from "../components/homepage/SlidingGallery";
import ProductFeatures from "../components/homepage/ProductFeatures";
import Testimonials from "../components/homepage/Testimonials";

function HomePage() {
  return (
    <div className="homepage">
      <Navbar />

      <Hero />
      <ImageSection />

      {/* Animations removed - components now load instantly */}
      <BrandStory />

      <SlidingGallery />

      <ProductFeatures />

      <Testimonials />

      <Footer />
    </div>
  );
}

export default HomePage;
